/* SVE PIT WALL — scroll-reveal + number count-up
 * Loaded once by snippets/sve-pit-wall-head.liquid.
 * Plain vanilla JS, no dependencies. */
(function () {
  if (typeof window === 'undefined') return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Auto-tag elements for reveal ────────────────────────────────── */
  // Anything matching these selectors gets a [data-sve-reveal] attr so the
  // CSS fade-up applies — saves us writing it inline in every section.
  var autoSelectors = [
    '.sve-hero__copy h1',
    '.sve-hero__lead',
    '.sve-hero__ctas',
    '.sve-stats__cell',
    '.sve-feature__info > div > *',
    '.sve-feature__media',
    '.sve-garage__header > *',
    '.sve-garage__tile',
    '.sve-catalogue__header > *',
    '.sve-card',
    '.sve-trust__head > *',
    '.sve-trust__item',
    '.sve-drop__copy > *',
    '.sve-drop__product',
    '.sve-footer__brand > *',
    '.sve-footer__col',
    '.sve-pdp__gallery',
    '.sve-pdp__info > *',
    '.sve-cta__copy > *',
    '.sve-cta__panel-cell'
  ];

  autoSelectors.forEach(function (sel) {
    var nodes = document.querySelectorAll(sel);
    Array.prototype.forEach.call(nodes, function (el, i) {
      if (el.hasAttribute('data-sve-reveal')) return;
      el.setAttribute('data-sve-reveal', '');
      // stagger siblings of the same parent (cap at ~600ms)
      var delay = Math.min(i * 70, 600);
      el.style.setProperty('--sve-reveal-delay', delay + 'ms');
    });
  });

  if (reduced) {
    // Skip the observer; just mark everything in.
    document.querySelectorAll('[data-sve-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  /* ── 2. IntersectionObserver to flip .is-in ─────────────────────────── */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

  document.querySelectorAll('[data-sve-reveal]').forEach(function (el) {
    io.observe(el);
  });

  /* ── 3. Stat number count-up ────────────────────────────────────────── */
  // Matches stat cells whose number is purely numeric (e.g. "48", "100",
  // not "±0.05" or "WW") — pure-text values are left alone.
  var statCells = document.querySelectorAll('.sve-stats__n');
  Array.prototype.forEach.call(statCells, function (el) {
    var raw = el.textContent.trim();
    // Parse: optional suffix (e.g. " H", "%", "MM"), grab the leading number.
    var m = raw.match(/^([0-9]+(?:\.[0-9]+)?)(.*)$/);
    if (!m) return;
    var target = parseFloat(m[1]);
    var suffix = m[2] || '';
    if (target < 1) return; // skip "±0.05" type values
    el.dataset.sveTarget = String(target);
    el.dataset.sveSuffix = suffix;
    el.textContent = '0' + suffix; // start state
  });

  function countUp(el) {
    var target = parseFloat(el.dataset.sveTarget);
    var suffix = el.dataset.sveSuffix || '';
    var dur = 1100; // ms
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / dur);
      // ease-out-cubic
      var eased = 1 - Math.pow(1 - t, 3);
      var val = target * eased;
      // Format: if target is integer, round; otherwise 2 dp.
      var formatted = (target % 1 === 0)
        ? Math.round(val).toString()
        : val.toFixed(2);
      el.textContent = formatted + suffix;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  var countObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && entry.target.dataset.sveTarget) {
        countUp(entry.target);
        countObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  Array.prototype.forEach.call(statCells, function (el) {
    if (el.dataset.sveTarget) countObserver.observe(el);
  });
})();
